import React from 'react';

interface ICameraIconProps {
	size?: string;
	fill?: string;
}

export const CameraIcon = ({ size = '48', fill }: ICameraIconProps) => (
	<svg aria-hidden="true" width={size} height={size} viewBox="0 0 49 48" fill="none">
		<path
			d="M13.3242 13.3333C14.1473 13.2883 14.9348 12.9724 15.5707 12.432L19.3236 8.90133C19.9593 8.36043 20.7469 8.04443 21.5702 8H27.4506C28.2666 8.04891 29.0464 8.36464 29.6764 8.90133L33.4293 12.432C34.0652 12.9724 34.8528 13.2883 35.6759 13.3333H42.6174C43.691 13.447 44.6846 13.9702 45.4028 14.8002C46.1213 15.6301 46.5124 16.7067 46.4997 17.8187V36C46.4997 37.0608 46.0908 38.0784 45.3627 38.8285C44.6346 39.5787 43.647 40 42.6174 40H6.3826C5.35296 40 4.36549 39.5787 3.6374 38.8285C2.90934 38.0784 2.5003 37.0608 2.5003 36V17.8187C2.48754 16.7067 2.87875 15.6301 3.5971 14.8002C4.31543 13.9702 5.30899 13.447 6.3826 13.3333H13.3242Z"
			stroke={fill || '#3D3D3D'}
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M24.5 33C28.9183 33 32.5 29.4183 32.5 25C32.5 20.5817 28.9183 17 24.5 17C20.0817 17 16.5 20.5817 16.5 25C16.5 29.4183 20.0817 33 24.5 33Z"
			stroke={fill || '#3D3D3D'}
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M40.0289 20.6664C39.6715 20.6664 39.3818 20.368 39.3818 19.9998C39.3818 19.6316 39.6715 19.3331 40.0289 19.3331"
			stroke={fill || '#3D3D3D'}
			strokeWidth="2"
		/>
		<path
			d="M40.0283 20.6664C40.3858 20.6664 40.6754 20.368 40.6754 19.9998C40.6754 19.6316 40.3858 19.3331 40.0283 19.3331"
			stroke={fill || '#3D3D3D'}
			strokeWidth="2"
		/>
	</svg>
);
